import { useStore } from "vuex";
import { computed, reactive, watch } from "vue";
import {
  getAward,
  getAwardLog,
  submitInfo,
} from "../api/survey";
import {
  SET_DEFAULT_ROLE,
  SET_DEFAULT_SERVER,
} from "../store/modules/user/mutations";
import { popupState } from "./popupHook";
import { getParam, setCookie } from "../utils";
import useClipboard from "vue-clipboard3";
import { nowLang, language } from "../language";
export const resultState = reactive({
  resultTips: "", // 结果页展示的文本
  checkTips: "", // 提示语
  hasCollect: false, // 是否已经完成信息收集
  isCoupon: false, // 是否为优惠券类型
  copyStatus: false, // 是否已复制
  finishAward: false, // 是否完成发奖
  showType: "", // 结果页类型， 不发奖common 发奖award 序列号series
  giftCode: "", // 展示的兑换码
  canClick: true, // 点击防抖
});
export const resultCollectInfo = reactive({
  phone: "",
  email: "",
  phoneArea: "",
});

const defaultInfo = {
  serverId:
    getParam("serverId") || getParam("server_id") || getParam("serverID"),
  sid: getParam("sid") || getParam("sId") || getParam("s_id"),
  roleId: getParam("roleId") || getParam("role_id") || getParam("roleID"),
  roleName: getParam("role_name") || getParam("roleName"),
};
const { toClipboard } = useClipboard();

export default function () {
  const store = useStore();
  const finishConfig = computed(() => store.state.survey.finishConfig);
  const uid = computed(() => store.state.user.uid);
  const loginAccount = computed(() => store.state.user.username);
  const isAward = computed(() => store.state.survey.isAward);

  const changeResultRoute = (type) => {
    resultState.showType = type;
    if (type === "collectInfo") {
      window.surveyDataLayer.push({
        eventName: "enter_contact_info",
      });
    }
  };
  const copyCode = () => {
    toClipboard(resultState.giftCode).then((res) => {
      resultState.copyStatus = true;
    });
  };

  const getSurveyAward = () => {
    if (!resultState.canClick) {
      return;
    }
    resultState.canClick = false;
    if (resultState.finishAward) {
      // 已经发奖则不重新发奖
      resultState.canClick = true;
      return;
    }
    let params = {
      id: window.id,
      language: nowLang.value,
    };
    let chooseServerIndex = store.state.user.serverIndex;
    let chooseRoleIndex = store.state.user.roleIndex;
    if (resultState.showType === "award" && !chooseServerIndex) {
      popupState.tips = language.getTextByKey("server");
      resultState.canClick = true;
      return;
    }
    if (resultState.showType === "award" && !chooseRoleIndex) {
      popupState.tips = language.getTextByKey("role");
      resultState.canClick = true;
      return;
    }
    params.server_id = chooseServerIndex
      ? store.state.user.serverList[chooseServerIndex].sid
      : defaultInfo.serverId;
    params.sid = chooseServerIndex
      ? store.state.user.serverList[chooseServerIndex].id
      : defaultInfo.sid;
    params.role_id = chooseRoleIndex
      ? store.state.user.roleList[chooseRoleIndex].roleID
      : defaultInfo.roleId;
    params.role_name = chooseRoleIndex
      ? store.state.user.roleList[chooseRoleIndex].roleName
      : defaultInfo.roleName;
    setCookie("role_name", encodeURIComponent(params.role_name), 1);
    getAward(params).then((res) => {
      // 请求发奖接口
      if (res.code === 1) {
        if (resultState.showType === "award") {
          resultState.resultTips = `${language.getTextByKey(
            "rewardSent"
          )} ${language.getTextByKey("checkInGame")}`;
          resultState.showType = "common";
        }
        if (resultState.showType === "series") {
          resultState.giftCode = res.data?.gift_data[0]?.card;
        }
        if (resultState.isCoupon) {
          resultState.resultTips = language.getTextByKey("rewardSent");
        }
        resultState.finishAward = true;
      } else {
        popupState.tips = `${language.getTextByCode(res.code)}[${res.code}]`;
      }
      resultState.canClick = true;
    });
  };
  const getCardCode = () => {
    // 查询序列号记录
    getAwardLog().then((res) => {
      if (+res.code === 1) {
        resultState.giftCode = res.data[0]?.card;
      } else {
        popupState.tips = `${language.getTextByCode(res.code)}[${res.code}]`;
      }
    });
  };
  const commitInfo = () => {
    let params = {};
    let phoneValue = resultCollectInfo.phone;
    let emailValue = resultCollectInfo.email;
    resultState.checkTips = "";
    let hasPhone = finishConfig.value.answer.find(
      (collect) => collect.collectType === "phone"
    );
    let hasEmail = finishConfig.value.answer.find(
      (collect) => collect.collectType === "email"
    );
    if (hasPhone && hasPhone.must && !phoneValue.length) {
      resultState.checkTips = language.getTextByKey("mustWrite");
      return false;
    }
    if (hasEmail && hasEmail.must && !emailValue.length) {
      resultState.checkTips = language.getTextByKey("mustWrite");
      return false;
    }
    if (phoneValue.length) {
      // 如果有手机号码内容，则补充phoneArea
      let phoneObjectConfig = finishConfig.value.answer.find(
        (item) => item.collectType === "phone"
      );
      let phoneCodeObjectConfig = phoneObjectConfig.ext.phoneCodeArr
        .map((item) => JSON.parse(item))
        .find((item) => +item.code === +resultCollectInfo.phoneArea);
      let checkLimit = phoneCodeObjectConfig.limit.some(
        (num) => phoneValue.length === +num
      );
      if (!checkLimit) {
        resultState.checkTips = language.getTextByKey("checkPhone");
        return false;
      }
      params.phoneArea = `${phoneCodeObjectConfig.area}+${phoneCodeObjectConfig.code}`;
      params.phone = phoneCodeObjectConfig.code + phoneValue;
    }
    if (emailValue.length) {
      let emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailReg.test(emailValue)) {
        resultState.checkTips = language.getTextByKey("checkEmail");
        return false;
      }
      params.email = emailValue;
      params.uid = uid.value;
      params.loginAccount = loginAccount.value;
    }
    submitInfo(params).then((res) => {
      if (+res.code === 1) {
        resultState.resultTips = `${language.getTextByKey(
          "submitted"
        )} ${language.getTextByKey("thanks")}`;
        resultState.hasCollect = true;
        resultState.showType = "common";
      } else {
        popupState.tips = `${language.getTextByCode(res.code)}[${res.code}]`;
      }
      window.surveyDataLayer.push({
        eventName: "contact_info",
        eventType: +res.code === 1 ? "提交成功" : "提交失败",
      });
    });
  };
  return {
    resultState,
    finishConfig,
    changeResultRoute,
    commitInfo,
    resultCollectInfo,
    copyCode,
    getSurveyAward,
    getCardCode,
    isAward,
  };
}
